import * as React from 'react';
import { createRoot } from 'react-dom/client';
import type { DefaultContinueHandlerType, RenderViewPropsType, RenderViewReturnType } from '../types';
import { CityModal } from '../../../React/features/Chat/features/CityModal';
import { FetchCitiesByPrefectureReturnType } from '../../../api/citiesByPrefecture/types';

export const COMPONENT_IDENTIFIER = 'city-modal';
const COMPONENT_ROOT_CLASS_NAME = `chat-${COMPONENT_IDENTIFIER}-container`;

export type RenderCityModalPropsType = RenderViewPropsType<FetchCitiesByPrefectureReturnType & {
  answerHandler: (event: React.MouseEvent<HTMLButtonElement>) => void;
}>

export const renderCityModal = async (props: RenderCityModalPropsType): RenderViewReturnType => {
  const { chatRoot, keyName } = props;

  // レンダーするためのルート要素を作成
  const viewContainer = document.createElement('div');
  const viewRoot = createRoot(viewContainer);

  // コンテナ要素にクラス付与
  viewContainer.classList.add(COMPONENT_ROOT_CLASS_NAME);
  viewContainer.classList.add(keyName);

  // チャットルートにコンテナ要素をappendする
  chatRoot.appendChild(viewContainer);

  return new Promise((resolve) => {
    const continueHandler = (args: DefaultContinueHandlerType) => resolve({ ...args, viewRootDomReference: viewContainer });

    // appendしたコンテナ要素にJsxをレンダリングする
    viewRoot.render(<CityModal {...props} continueHandler={continueHandler} />);
  });
};
